import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-confirm',
  templateUrl: './error-confirm.component.html',
  styleUrls: ['./error-confirm.component.scss']
})
export class ErrorConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
